import React from 'react';
import { ShippingMethod } from '../../../hooks/useCart/cart.rest';
import { ShippingMethodOption } from '../ShippingMethodOption';

import './ShippingMethodOptionList.scss';

interface Props {
  shippingOptions: ShippingMethod[];
  selectedOption: number;
  onSelectOption: (selectedOption: number) => void;
}

export const ShippingMethodOptionList: React.FC<Props> = ({
  shippingOptions,
  selectedOption,
  onSelectOption
}) => (
  <div className="ShippingMethodOptionList" role="radiogroup" aria-label="Shipping method">
    {shippingOptions.map((option: ShippingMethod) => (
      <ShippingMethodOption
        key={option.method}
        option={option}
        selected={option.method === selectedOption}
        onSelect={() => onSelectOption(option.method)}
      />
    ))}
  </div>
);
